import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import List from '@mui/material/List';
import { ContextPaper } from './context-paper';
import { ListHeader } from './list-header';
export function ContextMenu(props) {
    return (_jsxs(ContextPaper, { elevation: 3, onMouseLeave: () => {
            props.onClose();
        }, children: [_jsx(ListHeader, { children: props.title }), _jsx(List, { children: props.listItems })] }));
}
